import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ChampsManquants.module.css';

/**
 * Dit pourquoi le bouton de validation d'un dialogue est grisé : les champs
 * encore à remplir. Un bouton désactivé sans explication laisse la personne
 * chercher ce qui manque.
 */
export function ChampsManquants({ champs }: { champs: readonly string[] }): JSX.Element | null {
  const { t } = useTranslation(['regie']);
  if (champs.length === 0) return null;
  return (
    <p className={styles.manque} role="status">
      {t('regie:validation.pourContinuer', { champs: champs.join(', ') })}
    </p>
  );
}
